import React, { PureComponent } from 'react';
import injectSheet, {withTheme} from 'react-jss'

import Section from "../Widgets/Section"
import SectionTitle from "../Widgets/SectionTitle"
import CardGrid from '../Card/CardGrid'
import flow from 'lodash/flow'
import BackgroundContrastContainer from './BackgroundContrastContainer'

class LookbookRow extends PureComponent {
    render() {
      const { classes, theme, slice } = this.props;
      const {
          results, landing_page_uid, title, summary, link,
          background_contrast, show_article_summaries, carousel_on_mobile
      } = slice;

      if(!results || results.length === 0) return null;

      return (
        <BackgroundContrastContainer applyContrast={background_contrast === 'Yes'} data-cy="lookbookRowContainer">
          <SectionTitle text={title} summary={summary} color={theme.colors[landing_page_uid]} link={link} dataCy='lookbookRowHeader'/>
          <Section className={classes.root} dataCy='lookbookRowContent'>
            <CardGrid
              key={results}
              items={results}
              columns={4}
              singleLine={false}
              carousel={carousel_on_mobile === 'Yes'}
              variation='vertical'
              showSummary={show_article_summaries === 'Yes'}
            />
          </Section>
        </BackgroundContrastContainer>
      )
  }
}
export default flow([
  withTheme,
  injectSheet((theme) => ({
    root: {
      marginBottom: 0
    }
  })
)])( LookbookRow );



// WEBPACK FOOTER //
// ./src/components/LandingPage/LookbookRow.js